<template>
  <div v-if="length > Math.min(...pageCountSteps)" class="container d-flex justify-content-center">
    <div class="p-2">
      <b-pagination size="md" :total-rows="length" v-model="page" :per-page="pageCount"></b-pagination>
    </div>
    <div class="p-2">
      <select id="pagecount" class="form-control custom-select" v-model="pageCount">
        <option v-for="v in pageCountSteps" v-bind:value="v">{{ v }}</option>
      </select>
    </div>
  </div>
</template>

<style scoped>
.custom-control-label::after {
  top: 0.1rem;
}

.custom-control-label::before {
  top: 0.1rem;
}
</style>

<script>
export default {
  name: 'PaginationBlock',

  props: {
    value: { type: Object, default: {page: 1, pageCount: 10} },
    length: { type: Number, required: true },
    pageCountSteps: { type: Array, default: [10, 50] },
  },

  watch: {
    page: function(newV) {
      this.$emit('input', {page: newV, count: this.pageCount }); // emitting input signal so it works with v-model basic behaviour
    },
    pageCount: function(newV) {
      this.$emit('input', {page: this.page, count: newV }); // emitting input signal so it works with v-model basic behaviour
    },
  },

  data: () => ({
    page: 1,
    pageCount: 10,
  }),

  created () {
    this.pageCount = this.pageCountSteps[0];
  },
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/PaginationBlock.vue